import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ForgotPassword from './Container/Auth/ForgotPassword/ForgotPassword';
import Login from './Container/Auth/Login/Login';
import ResetPassword from './Container/Auth/ResetPassword/ResetPassword';
import SignUp from './Container/Auth/SignUp/SignUp';
import Dashboard from './Container/Dashboard/Dashboard';
import AllTenders from './Container/Pages/AllTenders/AllTenders';
import TenderDetails from './Container/Pages/AllTenders/TenderDetails';
import AppliedTenders from './Container/Pages/AppliedTenders/AppliedTenders';
import AssignedTenders from './Container/Pages/AssignedTenders/AssignedTenders';
import InterestedTenders from './Container/Pages/InterestedTenders/InterestedTenders';
import NotFound from './Container/Pages/NotFound/NotFound';
import Profile from './Container/Profile/Profile';
import MasterAdminLayout from './Layout/MasterAdminLayout';

const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false}
        newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      <Routes>
        <Route path="/dashboard" element={<MasterAdminLayout />}>
          <Route path="/dashboard/profile" element={<Profile />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/all-tenders" element={<AllTenders />} />
          <Route path="/dashboard/tender/:id" element={<TenderDetails />} />
          <Route path="/dashboard/assigned-tenders" element={<AssignedTenders />} />
          <Route path="/dashboard/interested-tenders" element={<InterestedTenders />} />
          <Route path="/dashboard/applied-tenders" element={<AppliedTenders />} />
        </Route>

        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
export default App;